export default __webpack_public_path__ + "media/images/icons_fc/chart4-d17f2156e3e79a93db88a355e00e82f1.png";